export default "__VITE_ASSET__CiBdml_s__"